import React, {useState} from "react";
import Modal from "react-modal";

const DownloadLogoPopup = ({ modalIsOpen, closeModal }) => {
  const [secondModalIsOpen, setSecondModalIsOpen] = useState(false);

  const openSecondModal = () => {
    closeModal(); // Close the first modal
    setSecondModalIsOpen(true); // Open the second modal
  };
  const closeSecondModal = () => setSecondModalIsOpen(false);

  return (
  <>
    <Modal isOpen={modalIsOpen} onRequestClose={closeModal} contentLabel="Modal">
      <div className="My__Overlay">
        <div className="My__OverlayIn">
        <div className="container">
          <div className="UFOSEC StatisticsSec3 popupcenter ">
            <button className="nobg closepopup d-flex align-items-center gap-1" onClick={closeModal}><span className="underline">Close</span> <img src="./images/XCircle.svg" className="img-fluid" /></button>
            <div className="text-center">
              <h2 className="mb-4 mt-2  w-100 good_times goldFont">Download Logos</h2>
            </div>
            <div className="cryptoDownload ">
              <div className="row">
                <div className="col-md-6 col-lg-4 col-xl-3">
                  <div className="subcontent subPad text-center p-3">
                    <span className="d-flex bothCoins justify-content-center mb-2"><img className="img-fluid" src="./images/ptgc/ufologo_circle.svg" /></span>
                    <h2 className="text-center">UFO Logo</h2>
                    <a href="" className=" mybtn underline text-white"><span>Download Logo</span></a>
                  </div>
                </div>
                <div className="col-md-6 col-lg-4 col-xl-3">
                  <div className="subcontent subPad text-center p-3">
                    <span className="d-flex bothCoins justify-content-center mb-2"><img className="img-fluid" src="./images/ptgc/ufologo_circle.svg" /></span>
                    <h2 className="text-center">UFO Logo</h2>
                    <a href="" className=" mybtn underline text-white"><span>Download Logo</span></a>
                  </div>
                </div>
                <div className="col-md-6 col-lg-4 col-xl-3">
                  <div className="subcontent subPad text-center p-3">
                    <span className="d-flex bothCoins justify-content-center mb-2"><img className="img-fluid" src="./images/ptgc/ufologo_circle.svg" /></span>
                    <h2 className="text-center">UFO Logo</h2>
                    <a href="" className=" mybtn underline text-white"><span>Download Logo</span></a>
                  </div>
                </div>
                <div className="col-md-6 col-lg-4 col-xl-3">
                  <div className="subcontent subPad text-center p-3">
                    <span className="d-flex bothCoins justify-content-center mb-2"><img className="img-fluid" src="./images/ptgc/ufologo_circle.svg" /></span>
                    <h2 className="text-center">UFO Logo</h2>
                    <a href="" className=" mybtn underline text-white"><span>Download Logo</span></a>
                  </div>
                </div>
              </div>
            </div>
        </div>
      </div>
      </div>
    </div>
    </Modal>
    </>
  );
};

export default DownloadLogoPopup;